<template>
    <div class="morelist">
        <div class="top">
            <a href="javascript:history.go(-1);" class="back">
                <i class="el-icon-arrow-left"></i>
            </a>
            {{title}}
        </div>
        <div class="news-list">
            <ul>
                <li  v-for="(item,index) in news" :key="index">
                    <a :href="item.url">
                        <div class="pic" v-if="item.img"><img :src="item.img" width="100%"></div>
                        <div class="title">{{item.title}}</div>
                        <div class="from">{{item.humantime}}</div>
                    </a>
                    <div class="clearfix"></div>
                </li>
            </ul>   
        </div>
    </div>
</template>

<script>
import jsonp from 'jsonp'

export default{
    name: 'GxnewsMore',
    data(){
        return{
            sortid: this.$route.params.sortid,
            title:'更多页',
            news:[],  
        }    
    },
    mounted(){
        jsonp('https://v.gxnews.com.cn/index.php?c=json&a=getArticles&detail=1&sortids='+this.sortid+'&start=0&limit=20', null, (err, data) => {
                if (err) {
                    console.error(err.message);
                } else {
                    console.log("news",data);
                    this.news = data;
                }
            })
    },
}
</script>

<style lang="less" scoped>
    .top{
        position: fixed;
        width: 100%;
        height: 1rem;
        line-height: 1rem;
        text-align: center;
        background: #fff;
        font-size: 0.43rem;
        font-weight: bold;
        color: #1960ab;
        left: 0;
        top: 0;
        z-index: 10;
        border-bottom: 1px solid #f1f1f1;
        .back{
            position: absolute;
            top: 0;
            left: 0.3rem;
            font-size: 0.6rem;
            color: #333;
        }
    }          
    .news-list{
        margin: 1.5rem 0;
        li{
            padding:  0.3rem 0.2rem 0.3rem;
            border-bottom: 1px solid #e2e2e2;
            margin-top: 0.25rem;
            &:nth-last-of-type(1){
                border-bottom: none;
            }
            .title{
                font-size: 0.42rem;
                color: #333;
            }
            .from{
                font-size: 0.32rem;
                color: #7f8080;   
                margin-top: 0.15rem; 
            }
            .pic{
                float: right;
                width: 120px;
                max-height: 80px;
                overflow: hidden;
            }
            .clearfix{
                clear: both;
            }
        }
    }

</style>
